import React, { useState } from "react";

import { UnloadingSvg } from "../../svgFiles/UnloadingSvg";

import TimeIcon from "../../images/time.svg";
import CartWeight from "../../images/cart_wt.svg";
import CartNumber from "../../images/cart_no.svg";
import TreyCount from "../../images/trey_count.svg";
import Type from "../../images/trey_type.svg";
import ExitTime from "../../images/exitTime.svg";
import Status from "../../images/status.svg";
import DateIcon from "../../images/calendar.svg";
import "../../components/shared/modalContent/overview.css";
import CommonModal from "../../components/shared/modalLayout/CommonModal";
import useTranslator from "../../hooks/useTranslator";

const ProcessingOverviewModal = ({ show, setShow, record, mode }) => {
  const [formData] = useState(record);
  const { _t } = useTranslator();

  const {
    oven,
    date_time_entered,
    time_entered,
    time_end,
    cart_number,
    strips_cart_weight,
    cheeks_cart_weight,
    treys_count,
    type,
    status,
  } = formData;

  const enetreddate = formatDateTime(date_time_entered).date;

  const handleClose = () => {
    setShow(false);
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      headerInfo={true}
      headername={_t("oven_logs_data", "Oven Logs Data")}
      BatchCodeInfo={false}
      PalletCode={`(${oven.name})`}
    >
      <h4 className="overViewtitle">{UnloadingSvg}{_t("data", "Data")}</h4>
      <ul className="overviewGrid processing mb-4">
        <li className="overviewGrid_card">
          <img src={DateIcon} alt="" />
          {_t("entered_date", "Entered Date")} : <span>{enetreddate}</span>
        </li>
        <li className="overviewGrid_card">
          <img src={TimeIcon} alt="" />
          {_t("entered_time", "Entered Time")} : <span>{time_entered}</span>
        </li>
        <li className="overviewGrid_card">
          <img src={CartWeight} alt="" />
          {_t("cart_weight", "Cart Weight")} : <span>{Number(cheeks_cart_weight) + Number(strips_cart_weight)}</span>
        </li>
        <li className="overviewGrid_card">
          <img src={CartNumber} alt="" />
          {_t("cart_number", "Cart Number")} : <span>{cart_number.name}</span>
        </li>
        <li className="overviewGrid_card">
          <img src={TreyCount} alt="" />
          {_t("treys_count", "Treys Count")} : <span>{treys_count}</span>
        </li>
        <li className="overviewGrid_card">
          <img src={Type} alt="" />
          {_t("type", "Type")} : <span>{type}</span>
        </li>
        <li className="overviewGrid_card">
          <img src={ExitTime} alt="" />
          {_t("end_time", "End Time")} : <span>{time_end}</span>
        </li>
        <li className="overviewGrid_card">
          <img src={Status} alt="" />
          {_t("status", "Status")} : <span>{_t(status, status === "bagged" ? "Bagged" : "Moved")}</span>
        </li>
      </ul>
    </CommonModal>
  );
};

export default ProcessingOverviewModal;
const formatDateTime = (isoString) => {
  if (!isoString) return "No Data Yet";

  const [date] = isoString.split(" ");

  return {
    date,
  };
};
